import * as React from "react";
import { Spinner } from "react-ui";

import { LoaderContainer } from "./Loader.styles";

interface LoaderProps {
    active: boolean;
    caption?: string;
    children: React.ReactElement;
}

export const Loader = ({ active, children, caption }: LoaderProps) => {
    if (active) {
        return (
            <LoaderContainer>
                <Spinner type="normal" caption={caption} />
            </LoaderContainer>
        );
    }

    return children;
};
